import { css } from '@emotion/react';
import { pausePaymentPlan } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import {
  Modal,
  TextareaField,
  useFormField,
  useModalLoadingState,
  useAlert,
  ModalControlModalProps,
} from '@frontend/design-system';
import { usePaymentPlanPollWorkflow } from '../../hooks/payment-plans/use-payment-plan-poll-workflow';

type PausePlanModalProps = ModalControlModalProps & {
  planId: string;
  onPlanPaused: (workflowId: string) => void;
};
export const PausePlanModal = ({ onClose, planId, onPlanPaused }: PausePlanModalProps) => {
  const { t } = useTranslation('payments');
  const { setLoading } = useModalLoadingState();
  const { refetchPlanDetails } = usePaymentPlanPollWorkflow({
    paymentPlanId: planId,
    onFailure: () => {
      alert.error(t('Error pausing payment plan. Please try again.'));
      setLoading(false);
    },
    onComplete: () => {
      alert.success(t('Plan successfully paused.'));
      refetchPlanDetails();
      onClose();
      setLoading(false);
    },
  });

  const alert = useAlert();
  const memoField = useFormField({ type: 'text', required: true });
  const handlePausePaymentPlan = async () => {
    setLoading(true);
    try {
      const response = await pausePaymentPlan(planId, memoField.value);
      onPlanPaused(response.data.workflowId);
    } catch (err) {
      console.warn('error was', err);
      alert.error(t('Error pausing payment plan. Please try again.'));
    }
  };
  return (
    <>
      <Modal.Header textAlign='left'>{t('Pause Payment Plan')}</Modal.Header>
      <Modal.Body>
        <TextareaField
          name='memo'
          label={t('Internal Note')}
          placeholder={t('Add an internal note...')}
          {...memoField}
          css={css`
            margin-top: ${theme.spacing(1)};
          `}
        />
      </Modal.Body>
      <Modal.Actions
        css={{ button: { width: 'fit-content' }, justifyContent: 'end', marginTop: theme.spacing(2) }}
        onPrimaryClick={handlePausePaymentPlan}
        primaryLabel={t('Pause')}
        onSecondaryClick={onClose}
        secondaryLabel={t('Cancel')}
      />
    </>
  );
};
